import flatten from 'lodash/flatten';
import { EventDateTimelineTimePoint, GetEventDateTimelineConfigsProps, getEventDateTimelineConfigs } from './get-event-date-timeline-configs';

export const getEventDateTimes = (props: GetEventDateTimelineConfigsProps, filter?: (time: EventDateTimelineTimePoint) => boolean) => {
  const configs = getEventDateTimelineConfigs(props);

  return flatten(configs.map(config => config.times)).filter(time => filter ? filter(time) : true);
};